import { classApi } from "../api/classApi";
import { useEffect, useState } from "react";
import type { LinkableGrade } from "../types/class.types";

/** Loads LMS courses for the class form course multi-select (mock mode). */
export function useLinkableGrades(enabled = true) {
  const [grades, setGrades] = useState<LinkableGrade[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setGrades([]);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    classApi
      .listLinkableGrades()
      .then((list) => {
        if (!cancelled) {
          setGrades(list);
        }
      })
      .catch((e) => {
        console.error(e);
        if (!cancelled) {
          setError("Could not load courses.");
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { grades, loading, error };
}
